import Walkthrough from '../../../../../../App/models/Walkthrough'
import useNormalizedSteps from '../../../../../../Walkthrough/hooks/useNormalizedSteps'
import { Chunk } from '../../../../../../Walkthrough/hooks/useRRWebEvents'

export const useContent = (walkthrough: Walkthrough, chunks: Chunk[]) => {
  const steps = useNormalizedSteps(walkthrough).filter((step) => step.visible)
  return { walkthrough, chunks, steps }
}
